module.exports = __webpack_public_path__ + "img/arrow-down-02.697d6a4e.svg";